var _circle, _g, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomizeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 50,
    width: 50,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.412
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.017 25.495c0-10.205 8.135-18.477 18.17-18.477 7.492 0 13.925 4.61 16.704 11.195m0 0l1.465-3.793m-1.465 3.793l-3.694-.99M43.356 24.067c0 10.205-8.135 18.478-18.17 18.478-7.491 0-13.924-4.611-16.703-11.195m0 0l-1.466 3.792m1.466-3.792l3.693.99",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.988 20.817l.767 1.503.736-1.503",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.434 23.072a2.386 2.386 0 01-.452-1.4c0-1.222.755-1.964 1.912-2.061.43-.502.854-1.048 1.845-1.048s1.267.546 1.696 1.048c1.157.097 2.062.84 2.062 2.06 0 .504-.161 1.002-.452 1.4M16.219 23.07a2.576 2.576 0 01-.002-3.622c.081-.082.218-.158.305-.128.114 0 .223.046.303.125l3.032 3.022a.426.426 0 010 .603"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.976 19.805c.187-1.565 1.316-2.745 2.626-2.745.21 0 .38.207.38.462v5.55"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.957 22.446c1.14 0 2.064.913 1.808 2.024l-.023.092h-1.46c.04-.139.076-.275.107-.41a.164.164 0 00.004-.082.172.172 0 00-.042-.067.544.544 0 00-.394-.146H16.028a.54.54 0 00-.395.148.172.172 0 00-.042.066.163.163 0 00.004.083c.231.961.685 2.052 1.546 2.893.828.808 2.151 1.503 4.372 1.503l.044-.001v1.411h-.044c-5.102 0-6.756-3.251-7.29-5.477-.267-1.114.66-2.036 1.805-2.037z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.17 31.379h7.994c.36 0 .662-.27.702-.628l.437-3.94a.706.706 0 00-.701-.784h-8.87a.706.706 0 00-.7.785l.437 3.939c.04.357.342.628.701.628z",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.412
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.78 27.854h12.775",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.412
  })));
}

export default __webpack_public_path__ + "media/images/consumer/signup/plans/customize_icon-e1dc63e8de41d25cabf0315cd692f9df.svg";
export { SvgCustomizeIcon as Component };